/**
 * O nome de cada movimento da gaveta, no Caixa e no fechamento (F217). Um
 * registro só para o site e o celular (F307).
 */
export const CASH_KIND_LABELS = {
    opening: 'Abertura',
    sale: 'Venda',
    refund: 'Devolução',
    withdrawal: 'Sangria',
    deposit: 'Suprimento',
    adjustment: 'Ajuste',
    expense: 'Gasto',
};
//# sourceMappingURL=cash.js.map